import Vue from 'vue'
import Vuex from 'vuex'
import system from './system'
import plan from './plan'
import access from './access'
import loader from './loader'
import company from './company'
import filter from './filter'
import companyUserParams from './companyUserParams'
import snackbar from './snackbar'
import snackbarPlan from './snackbarPlan'
import dialogPlan from './dialogPlan'
import snackbarButton from './snackbarButton'
import dialogWarning from './dialogWarning'
import dialogBeta from './dialogBeta'
import reportDialog from './reportDialog'
import stopWatch from './stopWatch'
import selectedBoard from './selectedBoard'
import customField from './customField'
import customFieldConnection from './customFieldConnection'
import automationMessage from './automationMessage'
import automationCreateTask from './automationCreateTask'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    system,
    plan,
    access,
    loader,
    company,
    filter,
    companyUserParams,
    snackbar,
    snackbarPlan,
    dialogPlan,
    snackbarButton,
    dialogWarning,
    dialogBeta,
    stopWatch,
    reportDialog,
    selectedBoard,
    customField,
    customFieldConnection,
    automationMessage,
    automationCreateTask
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js